import Winc from './winc.style.json';
import Default from './default.style.json';
import Rosebank from './rosebank.style.json';
import Hillcrest from './hilcrestcc.style.json';
import Jis from './jis.style.json';
import Stlaurence from './stlaurence.style.json';
import SCross from './sccc.style.json';
import Beaudesert from './beaudesert.style.json';
import Rockhampton from './rockhampton.style.json';
import PGOnline from './pgonline.style.json';
import PRSPNE from './prspne.style.json';
import ISFWaterloo from './isfwwaterloo.style.json';
import Bsssc from './bsssc.style.json';
import Albanyshs from './albanyshs.style.json';
import Aviationhigh from './aviationhigh.style.json';
import Avilacollege from './avilacollege.style.json';
import Biloelashs from './biloelashs.style.json';
import Bundabergshs from './bundabergshs.style.json';
import Gympieshs from './gympieshs.style.json';
import Malandashs from './malandashs.style.json';
import Mossmanshs from './mossmanshs.style.json';
import Namboursc from './namboursc.style.json';
import Nanangoshs from './nanangoshs.style.json';
import Pedarecc from './pedarecc.style.json';
import Proserpineshs from './proserpineshs.style.json';
import Redbankplains from './redbankplainsshs.style.json';
import SpringfieldCentral from './springfieldcentralshs.style.json';
import StJamesCollege from './stjamescollege.style.json';
import Spcc from './spcc.style.json';
import Tannumsands from './tannumsands.style.json';
import Tccr from './tccr.style.json';
import Vpshs from './vpshs.style.json';
import Wssc from './wssc.style.json';
import Wmyc from './wmyc.style.json';
import Woodscrestsc from './woodcrestsc.style.json';
import Yerongashs from './yerongashs.style.json';
import Suncoastcc from './suncoastcc.style.json';
import Chancellorsc from './chancellorsc.style.json';
import Indoorooshs from './indoorooshs.style.json';
import Stmaryscollege from './stmaryscollege.style.json';
import Sampoernaacademy from './sampoernaacademy.style.json';
import Aspleyshs from './aspleyshs.style.json';
import Warwickshswa from './warwickshswa.style.json';
import Wynnumshs from './wynnumshs.style.json';
import Trinitybayshs from './trinitybayshs.style.json';
import Sisschools from './sisschools.style.json';
import CharterHouse from "./charterhouse.style.json"
import Emmaus from './emmaus.style.json'
import Calliopeshs from './calliopeshs.style.json';
import Athertonshs from './athertonshs.style.json';
import Pronin from './pronin.style.json';
import Transylvania from './transylvania.style.json';
import VictoryCollege from './victorycollege.style.json';
import Bmezy from './bmezy.style.json';
import Peridis from './peridis.style.json';
import Calvary from './calvary.style.json';
import Scotspgc from './scotspgc.style.json';
import Ibid from './ibid.style.json';
import SevenSteps from './sevensteps.style.json';
import Dalby from './dalby.style.json';

export const Styles = {
  Winc,
  Default,
  Rosebank,
  Hillcrest,
  Jis,
  Stlaurence,
  SCross,
  Beaudesert,
  Rockhampton,
  PGOnline,
  PRSPNE,
  ISFWaterloo,
  Bsssc,
  Albanyshs,
  Aviationhigh,
  Avilacollege,
  Biloelashs,
  Bundabergshs,
  Gympieshs,
  Malandashs,
  Mossmanshs,
  Namboursc,
  Nanangoshs,
  Pedarecc,
  Proserpineshs,
  Redbankplains,
  SpringfieldCentral,
  StJamesCollege,
  Spcc,
  Tannumsands,
  Tccr,
  Vpshs,
  Wssc,
  Wmyc,
  Woodscrestsc,
  Yerongashs,
  Suncoastcc,
  Chancellorsc,
  Indoorooshs,
  Stmaryscollege,
  Sampoernaacademy,
  Aspleyshs,
  Warwickshswa,
  Wynnumshs,
  Trinitybayshs,
  Sisschools,
  CharterHouse,
  Emmaus,
  Calliopeshs,
  Athertonshs,
  Pronin,
  Transylvania,
  VictoryCollege,
  Bmezy,
  Peridis,
  Calvary,
  Scotspgc,
  Ibid,
  SevenSteps,
  Dalby,
};
